import { Container } from "@mui/material";
import Body from "./Body";
import Footer from "./Footer";
import HtmlCenterContainer from "./HtmlCenterContainer";
import HtmlContainer from "./HtmlContainer";

export default function Layout({
  sidebar = true,
  noHeader = false,
  children = "",
  breadCrumb = [],
  variant = "sidebar",
  bgColor = "white",
}) {
  return variant === "sidebar" ? (
    <HtmlContainer bgColor={bgColor}>
      <Body noHeader={noHeader}>{children}</Body>
      <Footer />
    </HtmlContainer>
  ) : variant === "empty" ? (
    <HtmlCenterContainer>
      <Container maxWidth="xs">{children}</Container>
    </HtmlCenterContainer>
  ) : (
    children
  );
}
